import { render, staticRenderFns } from "./Mgw.vue?vue&type=template&id=e2851b7e"
import script from "./Mgw.vue?vue&type=script&lang=js"
export * from "./Mgw.vue?vue&type=script&lang=js"
import style0 from "./Mgw.vue?vue&type=style&index=0&id=e2851b7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports